import instance from "../utils/axios.wrapper";
import { convertObjToQueryParams } from "../utils/basic.utils";
import { IAuthType } from "./authService.type";

export const sampleApiCall = async (body?: any) => {
  const axios = await instance("", "https://dummyjson.com/", true);
  const { data } = await axios.get("/todos");
  const result: IAuthType = await data;
  return result;
};

export const authSignUp = async (body: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post("api/v1/user/auth/signup", body);
  const result: IAuthType = await data;
  return result;
};

export const authSignUpInfo = async (body: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post("api/v1/auth/signup/additional-info", body);
  const result: IAuthType = await data;
  return result;
};

export const authSignIn = async (body: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post("api/v1/user/auth/login", body);
  const result = await data;
  return result;
};

export const authRefreshToken = async (body: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post("api/v1/user/auth/refresh-token", body);
  const result = await data;
  return result;
};

export const authRefreshSession = async () => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get("api/v1/user/auth/sessions-login");
  const result = await data;
  return result;
};

export const authLogout = async (body: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post("/api/v1/user/auth/logout", body);
  const result = await data;
  return result;
};

export const authSendverifyEmail = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post("api/v1/user/auth/verify-email/send-email");
  const result = await data;
  return result;
};

export const authConfirmToken = async (body: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post(
    "/api/v1/user/auth/verify-email/confirm-token",
    body
  );
  const result = await data;
  return result;
};

// For Updarting Users Informations

export const authUpdateDetails = async (body: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post("api/v1/user/auth/update-details", body);
  const result = await data;
  return result;
};

export const authUpdateDP = async (body: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.patch("api/v1/auth/update-dp", body);
  const result = await data;
  return result;
};

export const authUpdatePassword = async (body: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post("api/v1/user/auth/reset-password", body);
  const result = await data;
  return result;
};

export const authResetPassword = async (body: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post(
    "api/v1/user/auth/forgot-password/send-email",
    body
  );
  const result = await data;
  return result;
};

export const authSetNewPassword = async (body: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post(
    "api/v1/user/auth/forgot-password/confirm-token",
    body
  );
  const result = await data;
  return result;
};

// User Notifications

export const getUserNotifications = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(
    `api/v1/notifications${convertObjToQueryParams(body)}`
  );
  const result: any = await data;
  return result;
};

export const getUserNotification = async (id: string | number) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(`api/v1/notifications/${id}`);
  const result: any = await data;
  return result;
};

// User Activity
export const getUserRecentActivities = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(
    `api/v1/recent-activities${convertObjToQueryParams(body)}`
  );
  const result: any = await data;
  return result;
};
